import { createLoggerWithDefaults } from '@telus/core-logger'

const logger = createLoggerWithDefaults()

export default logger
